"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _reactHelmet = _interopRequireDefault(require("react-helmet"));

var _classnames = _interopRequireDefault(require("classnames"));

var _markdown = _interopRequireDefault(require("../markdown"));

require("./hero-banner.less");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 * Helper for rendering Video element.
 */
var Videos = function Videos(_ref) {
  var videos = _ref.videos;
  return (
    /*#__PURE__*/
    // display: 'none' by default, set to block in desktop media query
    _react["default"].createElement("video", {
      playsInline: true,
      autoPlay: true,
      loop: "loop",
      muted: true,
      style: {
        display: 'none'
      }
    }, videos.map(function (video) {
      return /*#__PURE__*/_react["default"].createElement("source", {
        key: video.fields.file.contentType,
        src: video.fields.file.url,
        type: video.fields.file.contentType
      });
    }))
  );
};

Videos.propTypes = {
  videos: _propTypes["default"].arrayOf(_propTypes["default"].shape({}))
};
Videos.defaultProps = {
  videos: []
};
/**
 * HeroBanner for page heros.
 * Can have a background image and/or video (desktop only).
 */

var HeroBanner = function HeroBanner(_ref2) {
  var backgroundImageMobile = _ref2.backgroundImageMobile,
      backgroundImage = _ref2.backgroundImage,
      backgroundImagePosition = _ref2.backgroundImagePosition,
      backgroundImagePositionMobile = _ref2.backgroundImagePositionMobile,
      className = _ref2.className,
      ctaButton = _ref2.ctaButton,
      displayOption = _ref2.displayOption,
      id = _ref2.id,
      showOverlay = _ref2.showOverlay,
      subtext = _ref2.subtext,
      title = _ref2.title,
      videos = _ref2.videos;
  // TODO make multiple bg images possible
  // Dangerously setting innerHtml because title comes from Contentful and want to allow markup
  // If we ever allow user or third party to provide this title, we must sanitize the input.
  // Doing this to allow <sup>'s to be used in the title element.
  // eslint-disable-next-line react/no-danger
  var Title = title ? /*#__PURE__*/_react["default"].createElement("h1", {
    className: "title",
    dangerouslySetInnerHTML: {
      __html: title
    }
  }) : null;
  var SubText = subtext ? /*#__PURE__*/_react["default"].createElement(_markdown["default"], {
    className: "subTitle",
    source: subtext
  }) : null;
  var Video = videos.length ? /*#__PURE__*/_react["default"].createElement(Videos, {
    videos: videos
  }) : null;
  var overlay = showOverlay ? /*#__PURE__*/_react["default"].createElement("div", {
    className: "overlay"
  }) : null;
  var heroBackgroundId = "heroBackground-".concat(id);
  var heroBackgroundClassNames = (0, _classnames["default"])('heroBackground', backgroundImagePosition, "".concat(backgroundImagePositionMobile, "-mobile"), {
    videoBackground: !!Video
  });
  var mobileImageStyle = backgroundImageMobile ? /*#__PURE__*/_react["default"].createElement("style", null, "\n        @media only screen and (max-width: 770px) {\n          #".concat(heroBackgroundId, " {\n            background-image: url(").concat(backgroundImageMobile, "?w=800);\n          }\n        }\n    ")) : null; // Preload background image on mobile devices, falling back to desktop version
  // if no mobile version is provided

  var preloadedMobileImage = backgroundImageMobile ? "".concat(backgroundImageMobile, "?w=800") : backgroundImage;
  var preloadedMobileImageLink = preloadedMobileImage ? /*#__PURE__*/_react["default"].createElement("link", {
    rel: "preload",
    href: preloadedMobileImage,
    as: "image",
    media: "(max-width: 770px)"
  }) : null;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "HeroBanner fullWidth ".concat(displayOption || className)
  }, /*#__PURE__*/_react["default"].createElement(_reactHelmet["default"], null, preloadedMobileImageLink), /*#__PURE__*/_react["default"].createElement("style", null, "\n          #".concat(heroBackgroundId, " {\n            background-image: url(").concat(backgroundImage, ");\n          }\n        ")), mobileImageStyle, /*#__PURE__*/_react["default"].createElement("div", {
    className: heroBackgroundClassNames,
    id: heroBackgroundId
  }, Video), /*#__PURE__*/_react["default"].createElement("div", {
    className: "heroContent"
  }, Title, SubText, ctaButton), overlay);
};

HeroBanner.propTypes = {
  backgroundImage: _propTypes["default"].string,
  backgroundImageMobile: _propTypes["default"].string,
  backgroundImagePosition: _propTypes["default"].string,
  backgroundImagePositionMobile: _propTypes["default"].string,
  className: _propTypes["default"].string,
  ctaButton: _propTypes["default"].node,
  displayOption: _propTypes["default"].string,
  id: _propTypes["default"].string,
  showOverlay: _propTypes["default"].bool,
  subtext: _propTypes["default"].string,
  title: _propTypes["default"].string,
  videos: _propTypes["default"].arrayOf(_propTypes["default"].object)
};
HeroBanner.defaultProps = {
  backgroundImage: null,
  backgroundImageMobile: null,
  backgroundImagePosition: 'alignCenter',
  backgroundImagePositionMobile: 'alignCenter',
  className: 'tall',
  id: null,
  ctaButton: null,
  displayOption: null,
  showOverlay: true,
  subtext: null,
  title: null,
  videos: []
};

var _default = /*#__PURE__*/(0, _react.memo)(HeroBanner);

exports["default"] = _default;